import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { rutClean, rutFormat } from 'rut-helpers';
import { MAX_RUT_DIGITS, MAX_LENGTH_RUT, ALLOWED_KEYS } from '../utils/constants';
@Directive({
	selector: '[appRutFormatter]',
})
export class RutFormatterDirective {
	constructor(private readonly control: NgControl) {}

	private formatRut(rut: string = ''): void {
		if (!this.control?.control) return;

		const formattedRut = rutFormat(rut.substring(0, MAX_LENGTH_RUT));

		if (formattedRut !== this.control.control.value) this.control.control.setValue(formattedRut);
	}

	@HostListener('input', ['$event'])
	onInput(event: Event): void {
		const input = event.target as HTMLInputElement | null;
		if (!input) return;
		this.formatRut(input.value);
	}

	@HostListener('keydown', ['$event'])
	onKeyDown(event: KeyboardEvent): void {
		const value = this.control?.control?.value || '';

		if (ALLOWED_KEYS.includes(event.key)) return;
		if (value.length >= MAX_LENGTH_RUT) event.preventDefault();
	}

	@HostListener('paste', ['$event'])
	onPaste(event: ClipboardEvent): void {
		event.preventDefault();

		const pastedText = rutClean(event.clipboardData?.getData('text') || '');
		const trimmed = pastedText.substring(0, MAX_RUT_DIGITS);

		this.formatRut(trimmed);
	}
}
